import * as yup from "yup";
import { InferType } from "yup";
import { ExceptionTypes } from "src/models/staffPriceExceptions/StaffPriceExceptionTypes";

export const exceptionSchema = yup.object({
  id: yup.string().nullable(),

  type: yup.string().oneOf(Object.values(ExceptionTypes)),

  details: yup.array().when("type", ([type], schema) => {
    return schema
      .of(yup.string().required(`${type === ExceptionTypes.Sku ? "SKU" : "Store Id"} is required`))
      .required(`${type === ExceptionTypes.Sku ? "SKU" : "Store Id"} is required`);
  }),

  price: yup.number().when("type", ([type], schema) => {
    if (type === ExceptionTypes.Sku) {
      return schema
        .typeError("Price is required")
        .required("Price is required")
        .min(0, "Price must be zero or more")
        .test(
          "max-2-decimals",
          "Price can have at most 2 decimal places",
          (value) => value === undefined || /^\d+(\.\d{1,2})?$/.test(value.toString())
        );
    }
    return schema.nullable();
  }),

  authorisedBy: yup.string().required("Authorised by is required"),

  comment: yup.string().required("Comment is required").max(100, "Comment must be at most 100 characters"),

  isActive: yup.boolean().nullable(),

  startDate: yup.string().nullable(),
  endDate: yup.string().nullable(),
});

// Schema for entire form model
export const createExceptionSchema = yup.object({
  exceptions: yup.array().of(exceptionSchema).min(1, "Please add at least one SKU exception"),
});

export type CreateExceptionModel = InferType<typeof createExceptionSchema>;
